import { differenceInCalendarDays, format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { NULL_TIME } from '../../../constants';

// Due dates are Eastern calendar days and step dates are Eastern wall clock, wherever the viewer is.
const EASTERN = 'America/New_York';

/** A step date counts once it holds a real date: not NULL_TIME, empty, or MySQL's zero date. */
export const isDateSet = (value: string) =>
  value !== '' && value !== NULL_TIME && !value.startsWith('0000-00-00');

/** Today in Eastern time, as yyyy-MM-dd. */
export const easternToday = (now: Date) => formatInTimeZone(now, EASTERN, 'yyyy-MM-dd');

/** Now as Eastern wall clock, the way step dates and History rows are stored. */
export const easternTimestamp = (now: Date) =>
  formatInTimeZone(now, EASTERN, 'yyyy-MM-dd HH:mm:ss');

/** Whole Eastern calendar days past the due date; 0 on the day it's due or before. */
export const daysLate = (dueDate: string, now: Date) =>
  isDateSet(dueDate)
    ? Math.max(
        0,
        differenceInCalendarDays(parseISO(easternToday(now)), parseISO(dueDate.slice(0, 10))),
      )
    : 0;

export const daysLateLabel = (days: number) => (days === 1 ? '1 day late' : `${days} days late`);

/** "Oct 3, 2026", or the worded empty when the date isn't set. */
export const dateLabel = (value: string, empty: string) =>
  isDateSet(value) ? format(parseISO(value.slice(0, 10)), 'MMM d, yyyy') : empty;

/** A day picked in a DateInput, as a review date column stores it. */
export const reviewDateValue = (day: Date) => `${format(day, 'yyyy-MM-dd')} 00:00:00`;

/** Today in Eastern time as a local midnight Date, for a DateInput's default. */
export const easternTodayAsLocalDate = (now: Date) => parseISO(easternToday(now));
